import React, { useRef, useState } from "react";
import { RCCBadge, RCCButton, RCCGrid, RCCRefModalProps, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { v4 } from "uuid";
import List from "../List";
import Modal from "../Modal";
import { ModalCenter } from "../Modal/styles";
import { IListImportFiles } from "./interface";

const ListImportFiles: React.FC<IListImportFiles> = ({
	importedFiles
}) => {
	const {translate} = useTranslation();
	const [messageLog,setMessageLog] = useState<Array<string>>();
	const modalMessages = useRef<RCCRefModalProps>(null);
    
	const colStatus = (row: any) => { 
		
		let statusColor:"green"|"yellow"|"red";
		switch (row.status) {
		case "Sucesso":
			statusColor = "green";
			break;
		case "Aviso":
			statusColor = "yellow";
			break;
		default:
			statusColor = "red";
			break;
		}

		return(	
			<RCCBadge 
				color={statusColor}
				styleInline="font-size: 0.83rem;"
			>
				{translate(row.status)}
			</RCCBadge>
		);
	};
	
	const colMsg = (row: any) => (	
		row.message ? 
			<RCCTooltip
				text={translate("Mensagens")}
			>
				<RCCButton
					icon={{name:"stack", color:"grey", size:20}} 
					color="transparent"
					onClick={() => {
						setMessageLog(row.message.split("\n"));
						modalMessages.current?.openModal();
					}}
				/>
			</RCCTooltip>
			:
			<></>
	);
    
	if(!importedFiles || importedFiles.length === 0)
		return null;

	return <>
		<List 
			data={importedFiles}
			columns={[{
				idColumn: "fileName",
				nameColumn: translate("Nome do arquivo"),
				xs: 12,
				sm: 4,
				justify: "left"
			},{
				idColumn: "processed",
				nameColumn: translate("Processados"),
				xs: 12,
				sm: 2,
				justify: "right"
			},{
				idColumn: "imported",
				nameColumn: translate("Importados"),
				xs: 12,
				sm: 2,
				justify: "right"
			},{
				idColumn: "status",
				nameColumn: translate("Status"),
				xs: 12,
				sm: 2,
				justify: "center",
				cellRenderer: colStatus
			},
			{
				idColumn: "message",
				nameColumn: " ",
				xs: 12,
				sm: 2,
				justify: "left",
				cellRenderer: colMsg
			}]}
			showHeader
		/>
		<Modal
			ref={modalMessages}
			header={{
				title: translate("Mensagens"),
				icon: {
					name: "info"
				}
			}}
			footer= {{
				showSaveButton: false,
				cancelButtonText: translate("Ok")
			}}
			withoutForm
			styleInline={ModalCenter}
		>
			<RCCGrid
				container
				item
				direction="column"
				styleInline="font-size: 0.83rem;"
			>
				{messageLog?.map((message,index) => (
					<React.Fragment key={v4()}>
						<p>{message}</p>
						{index !== messageLog.length - 1 && <hr/>}
					</React.Fragment>
				))}
			</RCCGrid>
		</Modal>
	</>;
};

export default ListImportFiles;
